import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import Button, { ButtonProps } from "../button";
import { useControlGroupSize } from "./context";
import {
  controlGroupContentSizeStyles,
  controlGroupSizeStyles,
} from "./styles";

const ControlGroupButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size, style, ...props }, ref) => {
    const resolvedSize = useControlGroupSize(size);

    return (
      <Button
        {...props}
        ref={ref}
        size={resolvedSize}
        style={{
          ...(size ? controlGroupSizeStyles[size] : undefined),
          ...style,
        }}
        className={twMerge(
          clsx(
            "control-group-action h-full rounded-none border-0 shadow-none",
            "enabled:shadow-none enabled:hover:shadow-none focus-visible:outline-hidden",
            controlGroupContentSizeStyles,
          ),
          className,
        )}
      />
    );
  },
);

export default ControlGroupButton;
